export default {
  title: 'Produse',
  order_note: 'Notă comandă',
};
